module.exports = __webpack_public_path__ + "static/media/marker.e10c923f.svg";